import { gql } from '@apollo/client'

export default gql(`
  mutation add_colleague_to_project($id: ID!, $email: String!) {
    add_colleague_to_project(id: $id, email: $email) {
      id
    }
  }
`)
